import { Edges } from '@react-three/drei'
import type { Vehicle } from '../../../types/optimization'

const M = (mm: number) => mm / 1000

export function VehicleObstacles({ vehicle }: { vehicle: Vehicle | null | undefined }) {
  const obstacles = (vehicle as any)?.obstacles || []
  if (!obstacles.length) return null

  return (
    <group>
      {obstacles.map((obstacle: any, index: number) => {
        const x = Number(obstacle.position?.x ?? obstacle.x ?? 0)
        const y = Number(obstacle.position?.y ?? obstacle.y ?? 0)
        const z = Number(obstacle.position?.z ?? obstacle.z ?? 0)
        const length = Number(obstacle.dimensions?.length ?? obstacle.length ?? 0)
        const width = Number(obstacle.dimensions?.width ?? obstacle.width ?? 0)
        const height = Number(obstacle.dimensions?.height ?? obstacle.height ?? 0)
        if (!length || !width || !height) return null

        return (
          <mesh
            key={obstacle.id ?? `obstacle-${index}`}
            position={[M(x + length / 2), M(z + height / 2), M(y + width / 2)]}
          >
            <boxGeometry args={[M(length), M(height), M(width)]} />
            <meshStandardMaterial color="#ef4444" transparent opacity={0.22} depthWrite={false} />
            <Edges color="#ef4444" />
          </mesh>
        )
      })}
    </group>
  )
}
